import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0551c2bf&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=0551c2bf&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=0551c2bf&prod&scoped=true&lang=scss"
import style2 from "../src/modules/gpt/assets/css/index.scss?vue&type=style&index=2&id=0551c2bf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551c2bf",
  null
  
)

export default component.exports